import { render, staticRenderFns } from "./CreateDistroCenter.vue?vue&type=template&id=3dcccddd&scoped=true"
import script from "./CreateDistroCenter.vue?vue&type=script&lang=js"
export * from "./CreateDistroCenter.vue?vue&type=script&lang=js"
import style0 from "./CreateDistroCenter.vue?vue&type=style&index=0&id=3dcccddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcccddd",
  null
  
)

export default component.exports